import SelectOption from "react-select";
const Select = (props) => {
  const selectStyle = {
    control: (styles, state) => {
      return {
        ...styles,
        // backgroundColor: "rgb(var(--input-background-rgb))",
        minHeight: "44px",
        border: "1px solid black"
      }
    },
    menu: (styles) => ({
      ...styles,
      //   backgroundColor: "rgb(var(--input-background-rgb))",
      border: "1px solid rgba(var(--input-foreground-rgb), 0.32)",
    }),
    option: (styles, { data, isDisabled }) => {
      return {
        ...styles,
        // backgroundColor: "rgb(var(--input-background-rgb))",
        color: (props?.customStyle?.textColor && data?.availability === 0) ? props?.customStyle?.textColor : "color: rgba(var(--input-foreground-rgb), 0.7)",
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          //   backgroundColor: "rgb(var(--input-background-rgb), 0.63)",
        },
      };
    },
    input: (styles) => ({
      ...styles,
      color: "rgba(var(--input-foreground-rgb), 0.7)",
    }),
    placeholder: (styles) => ({
      ...styles,
      color: "rgba(var(--input-foreground-rgb), 0.7)",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "rgb(var(--foreground-rgb))",
    }),
    multiValue: (styles) => ({ ...styles, display: "block" }),
  };
  return <SelectOption {...props} styles={selectStyle} />;
};

export default Select;
